























































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mixinz } from '@/scripts/global/mixinz';

export interface Point {
  Id: number;
  Name: string;
  TypeId: number;
  ChildItems: Point[];
  Parents?: string[];
}

/**
 * Nokta Analiz Raporu icin nokta secici (Kutuphane > Raporlar). Eskiden ayri bir ekrandi
 * (PointAnalysisReport); tarih ve Excel uretimi Reports.vue'ya tasindi, burada yalnizca secim kaldi.
 * Secim v-model ile ust bilesende tutulur: rapor degistirilip geri donulunce kaybolmasin.
 */
@Component<PointSelector>({
  mixins: [mixinz],
})
export default class PointSelector extends Vue {
  @Prop({ type: Array, default: () => [] }) value!: Point[];

  pointList: Point[] = [];
  openIds: string[] = [];
  searchText = "";
  isDataLoading = false;

  async created() {
    await this.fetchData();
  }

  async fetchData() {
    this.isDataLoading = true;
    const searchText = this.searchText || undefined;
    this.pointList = (await this.$globalApiClient.pointAnalysis.GetAllPointsHierarchical({ searchText })).data;
    this.addParents(this.pointList);
    this.isDataLoading = false;
  }

  addParents(points: Point[], parents: string[] = []) {
    points.forEach(point => {
      point.Parents = [...parents];
      if (point.ChildItems) {
        this.addParents(point.ChildItems, [...parents, point.Name]);
      }
    });
  }

  handleRowClick(Id: string) {
    if (this.openIds.includes(Id)) {
      this.openIds.splice(this.openIds.indexOf(Id), 1);
    } else {
      this.openIds.push(Id);
    }
  }

  isSelected(item: Point) {
    return this.value.some(point => point.Id === item.Id);
  }

  handleCheckBoxClick(item: Point) {
    const selected = this.isSelected(item)
      ? this.value.filter(point => point.Id !== item.Id)
      : [...this.value, item];
    this.$emit('input', selected);
  }
}
